import script from "./HomeAboutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAboutComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeAboutComponent.vue?vue&type=style&index=0&id=cd7f570a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-morula\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd7f570a"]])

export default __exports__